<template>
  <div class="bg-white px-md-3">
    <router-view #default="{ Component }">
      <component
        :is="Component"
        class="py-md-4 px-0 col-12"/>
    </router-view>
  </div>
</template>

<script setup>
import { useHideIntercomLauncher } from '@shared/composables/intercom.js'
import { useHideToastNotifications } from '@/composables/toastNotifications.js'
import useScreenSize from '@shared/composables/screenSize.js'

useHideIntercomLauncher()
const { isMobile } = useScreenSize()
useHideToastNotifications({ predicate: isMobile, type: 'persistent' })
</script>
